import { render, staticRenderFns } from "./BtnFixed.vue?vue&type=template&id=8a7f67d6&scoped=true&"
import script from "./BtnFixed.vue?vue&type=script&lang=js&"
export * from "./BtnFixed.vue?vue&type=script&lang=js&"
import style0 from "./BtnFixed.vue?vue&type=style&index=0&id=8a7f67d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7f67d6",
  null
  
)

export default component.exports